// Helper per "aggiungi al calendario" senza backend: link Google Calendar + file .ics.
// Usato dalla "prossima azione" del lead per creare un promemoria nel calendario reale.

interface CalEvent {
    title: string;
    start: Date;
    end?: Date; // default start + 30 min
    details?: string;
    location?: string;
}

const pad = (n: number) => String(n).padStart(2, '0');

// Formato UTC compatto richiesto da Google Calendar / iCalendar: YYYYMMDDTHHMMSSZ
function fmtUTC(d: Date): string {
    return (
        `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}` +
        `T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`
    );
}

function endOf(o: CalEvent): Date {
    return o.end ?? new Date(o.start.getTime() + 30 * 60 * 1000);
}

/** URL "Aggiungi a Google Calendar" (apre la compose precompilata). */
export function googleCalendarUrl(o: CalEvent): string {
    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: o.title,
        dates: `${fmtUTC(o.start)}/${fmtUTC(endOf(o))}`,
    });
    if (o.details) params.set('details', o.details);
    if (o.location) params.set('location', o.location);
    return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

// escape per i valori iCalendar
const esc = (s: string) => s.replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n');

/** Data URI di un file .ics (Apple/Outlook/telefono) con sveglia 10 min prima. */
export function icsDataUri(o: CalEvent): string {
    const uid = `${o.start.getTime()}-${Math.round(Math.random() * 1e6)}@pixel-lead`;
    const lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Pixel//Lead//IT',
        'CALSCALE:GREGORIAN',
        'BEGIN:VEVENT',
        `UID:${uid}`,
        `DTSTAMP:${fmtUTC(new Date())}`,
        `DTSTART:${fmtUTC(o.start)}`,
        `DTEND:${fmtUTC(endOf(o))}`,
        `SUMMARY:${esc(o.title)}`,
    ];
    if (o.details) lines.push(`DESCRIPTION:${esc(o.details)}`);
    if (o.location) lines.push(`LOCATION:${esc(o.location)}`);
    lines.push(
        'BEGIN:VALARM',
        'TRIGGER:-PT10M',
        'ACTION:DISPLAY',
        `DESCRIPTION:${esc(o.title)}`,
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR',
    );
    return `data:text/calendar;charset=utf-8,${encodeURIComponent(lines.join('\r\n'))}`;
}
